import identificationRecord from './identificationRecord'

const zhCN = { identificationRecord: identificationRecord.zhCN }
const enUS = { identificationRecord: identificationRecord.enUS }
export default { zhCN, enUS }